import { useProfileImageModalStore } from "../../../js/stores/profile-image-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { ProfileImageModal } from "./profile-image-modal";

export const ProfileImageWidget = ({ avatarUrl, externalAvatarUrl, avatarInitials }) => {
  const isModalOpen = useProfileImageModalStore((state) => state.isModalOpen);
  const openModal = useProfileImageModalStore((state) => state.openModal);
  const closeModal = useProfileImageModalStore((state) => state.closeModal);
  const updateIsModalOpen = useProfileImageModalStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <div className="profile-image__wrapper">
      <div
        className="profile-image__avatar"
        style={{backgroundImage: `url(${avatarUrl || externalAvatarUrl})`}}
      >
        {avatarInitials}
      </div>

      <button className="profile-image__popup-button" onClick={openModal}>Upload image</button>

      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={() => updateIsModalOpen(false)}
          onOpenChange={updateIsModalOpen}
        >
          <DialogContent>
            <ProfileImageModal closeModal={closeModal} />
          </DialogContent>
        </Dialog>
      )}
    </div>
  )
}